import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { SearchesState } from './types'

export const initialState: SearchesState = {
  step: {
    query: '',
    focus: false
  },
  dialog: {
    query: ''
  },
  media: {
    query: ''
  }
}

export const { reducer, actions } = createSlice({
  name: 'searches',
  initialState,
  reducers: {
    setStepSearch: (state, { payload }: PayloadAction<{ value: string }>) => {
      state.step.query = payload.value
    },
    setIsStepSearchFocus: (state, { payload }: PayloadAction<boolean>) => {
      state.step.focus = payload
    },
    setDialogSearch: (state, { payload }: PayloadAction<string>) => {
      state.dialog.query = payload
    },
    setMediaSearch: (state, { payload }: PayloadAction<string>) => {
      state.media.query = payload
    }
  }
})
